import { IconButton, TextField } from '@material-ui/core'
import React, { useEffect, useState } from 'react'

import { Search } from '@material-ui/icons'
import { colors } from '@vestaboard/installables'
import { makeStyles } from '@material-ui/core/styles'

interface ISearchInput {
  value?: string
  size?: 'small' | 'medium'
  onSearch: (term: string) => void
}

const useStyles = makeStyles({
  input: {
    width: 200,
    backgroundColor: colors.white
  }
})

export const SearchInput = (props: ISearchInput) => {
  const [value, setValue] = useState(typeof props.value === 'string' ? props.value : '')
  const classes = useStyles()

  useEffect(() => {
    if (props.value !== value) {
      setValue(typeof props.value === 'string' ? props.value : '')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.value])

  return (
    <form
      onSubmit={e => {
        e.preventDefault()
        props.onSearch(value)
      }}>
      <TextField
        className={classes.input}
        size={props.size || 'small'}
        variant='outlined'
        label='Search'
        value={value}
        onChange={e => setValue(e.target.value)}
        InputProps={{
          endAdornment: (
            <IconButton type='submit'>
              <Search />
            </IconButton>
          )
        }}
      />
    </form>
  )
}
